import { render, staticRenderFns } from "./index4-single.vue?vue&type=template&id=2bffc0ba&scoped=true&"
import script from "./index4-single.vue?vue&type=script&lang=js&"
export * from "./index4-single.vue?vue&type=script&lang=js&"
import style0 from "./index4-single.vue?vue&type=style&index=0&id=2bffc0ba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bffc0ba",
  null
  
)

export default component.exports